import { Controller } from "@hotwired/stimulus"

// Handles radio card group selection state for visual indicators
// Place on a container that wraps all radio card options
export default class extends Controller {
  static targets = ["card"]

  connect() {
    this.updateAllCards()
  }

  updateAllCards() {
    this.cardTargets.forEach(card => {
      const radio = card.querySelector("input[type='radio']")
      const indicator = card.querySelector("[data-indicator]")
      const check = card.querySelector("[data-check]")

      if (!radio || !indicator || !check) return

      if (radio.checked) {
        indicator.classList.remove("border-gray-300", "dark:border-gray-600")
        indicator.classList.add("border-primary-500", "bg-primary-500")
        check.classList.remove("opacity-0")
        check.classList.add("opacity-100")
      } else {
        indicator.classList.add("border-gray-300", "dark:border-gray-600")
        indicator.classList.remove("border-primary-500", "bg-primary-500")
        check.classList.add("opacity-0")
        check.classList.remove("opacity-100")
      }
    })
  }
}
